import React from 'react';
import { useContactName } from 'App/helpers/contactNames';
import { getContactCardHref } from 'App/helpers/contactCardNavigation';

export const ContactLink = ({ id, name }: { id: number; name: string }) => (
	<a href={getContactCardHref(id)} onClick={e => e.stopPropagation()}>
		{name}
	</a>
);

/** A Contact field's value: the contact's current name linking to its card, or nothing once the contact is gone. */
const ContactName = ({ value }: { value?: string | number | null }) => {
	const name = useContactName(value);
	return name ? <ContactLink id={Number(value)} name={name} /> : null;
};

export default ContactName;
